import {
  AnimatedBadge,
  type AnimatedBadgeStatus,
} from "@/components/motion/animated-badge";
import { paidFeaturesLive } from "@/lib/tier-blocking";

export type Tier = "advanced" | "premium";

const STATUS: Record<Tier, AnimatedBadgeStatus> = {
  advanced: "warning",
  premium: "info",
};

const LABELS: Record<Tier, string> = {
  advanced: "Advanced",
  premium: "Premium",
};

export function TierBadge({
  tier,
  className,
}: {
  tier: Tier;
  className?: string;
}) {
  if (!paidFeaturesLive()) return null;
  return (
    <AnimatedBadge
      status={STATUS[tier]}
      size="sm"
      showIcon={false}
      contentKey={tier}
      className={className}
    >
      {LABELS[tier]}
    </AnimatedBadge>
  );
}
